/** 处罚方式枚举 */
export enum PunishmentTypeEnum {
    /** 下架 */
    TAKEOFF = 1,
    /** 冻结 */
    FREEZE = 2,
    /** 扣分 */
    PENALTIES = 3,
}
/** 处罚方式文字枚举 */
export enum PunishmentTypeCnEnum {
    下架 = PunishmentTypeEnum.TAKEOFF,
    冻结 = PunishmentTypeEnum.FREEZE,
    扣分 = PunishmentTypeEnum.PENALTIES,
}

/** 处罚状态 */
export enum PunishmentStatusEnum {
    /** 已处罚 */
    PUNISHMENT = 0,
    /** 已取消 */
    CANCEL,
}

/**
 * 处罚状态
 */
export enum PunishStatusEN {
    /** 正常 */
    normal = 1,
    /** 冻结 */
    rest,
    /** 永久下架 */
    dropOff,
}

/** 处罚对象枚举 */
export enum PunishmentTargetEnum {
    PROVIDER = 1,
    SERVICE = 2,
}

/** 处罚对象文字枚举 */
export enum PunishmentTargetCnEnum {
    服务商 = PunishmentTargetEnum.PROVIDER,
    服务 = PunishmentTargetEnum.SERVICE,
}

/**
 * 处罚状态
 */
export enum PunishStatusZH {
    正常 = 1,
    冻结,
    永久下架,
}

/** 处罚状态文字 */
export enum PunishmentStatusCnEnum {
    /** 已处罚 */
    已处罚 = PunishmentStatusEnum.PUNISHMENT,
    /** 已取消 */
    已撤销 = PunishmentStatusEnum.CANCEL,
}
